var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"sidebar-logo-link",attrs:{"to":"/"}},[_c('img',{staticClass:"sidebar-logo",attrs:{"src":require("@/assets/images/home/logo.png")}}),(!_vm.isCollapse)?_c('div',{staticClass:"sidebar-title"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }